import React from "react";

export const InitialAppShell: React.FC = () => (
  <div
    data-testid="initial-app-shell"
    className="relative min-h-screen overflow-hidden bg-white"
    aria-busy="true"
  >
    <div className="border-b border-slate-100 bg-white">
      <div className="mx-auto flex h-[76px] max-w-[90rem] items-center justify-between px-4 sm:px-6 lg:px-8">
        <img
          src="/final-logo-icon.png"
          alt=""
          aria-hidden="true"
          className="h-6 w-auto sm:h-7"
        />
        <div aria-hidden="true" className="flex items-center gap-3">
          <span className="hidden h-11 w-16 rounded-xl bg-slate-100 sm:block" />
          <span className="h-11 w-24 rounded-xl border border-blue-100 bg-blue-50" />
          <span className="h-11 w-11 rounded-xl border border-slate-200 bg-white" />
        </div>
      </div>
    </div>

    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-[-26rem] h-[64rem] w-[64rem] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(90,214,255,0.48)_0%,rgba(61,123,255,0.20)_38%,rgba(255,255,255,0)_70%)] blur-2xl"
    />
    <div
      aria-hidden="true"
      className="relative mx-auto flex max-w-4xl flex-col items-center px-5 pb-20 pt-20 sm:px-6 sm:pt-24"
    >
      <span className="h-12 w-52 rounded-2xl border border-blue-100 bg-white/80 shadow-sm" />
      <span className="mt-8 h-12 w-[92%] max-w-3xl rounded-2xl bg-slate-100/80 sm:h-16" />
      <span className="mt-3 h-12 w-[68%] max-w-xl rounded-2xl bg-blue-100/75 sm:h-16" />
      <span className="mt-8 h-5 w-[78%] max-w-2xl rounded-full bg-slate-100/80" />
      <span className="mt-3 h-5 w-[58%] max-w-lg rounded-full bg-slate-100/70" />
      <span className="mt-10 h-20 w-full max-w-3xl rounded-[1.25rem] border border-slate-200 bg-white shadow-[0_24px_70px_rgba(37,99,235,0.10)]" />
    </div>
  </div>
);
